import { Toaster } from "react-hot-toast";
import Header from "./Header";
import Sidebar from "./Sidebar";

export default function DashboardLayout({ children }) {
  return (
    <>
    <Toaster />
      {/* Header */}
      <Header />

      {/* Body */}
      <div className="flex bg-[#fafbfe] h-screen">
        {/* Sidebar */}
        
        <Sidebar />

        {/* Right Content */}
        <main className=" flex-1 min-w-0 px-[30px] py-5 ">
          {children}
        </main>
      </div>
    </>
  );
}
